import React from "react";

export function Contact() {
    return <>
        <h5 className="my-10 text-3xl tracking-widest font-bold text-black md:text-5xl">Contact</h5>
        <form id="contact" action="https://formspree.io/f/mzbnkqjg" method="POST" acceptCharset="UTF-8"
              className="mx-auto w-full max-w-xl">
            <input
                id="name"
                type="text"
                name="name"
                placeholder="Your Name"
                className="my-2 h-12 w-full border-0 bg-gray-100 px-4 font-['Proxima_Nova_Alt_Light'] text-base font-black tracking-wide text-gray-700"
            />
            <br/>
            <input
                id="email"
                type="text"
                name="email"
                placeholder="Email Address"
                className="my-2 h-12 w-full border-0 bg-gray-100 px-4 font-['Proxima_Nova_Alt_Light'] text-base font-black tracking-wide text-gray-700"
            />
            <br/>
            <textarea
                id="message"
                rows={5}
                name="message"
                form="contact"
                placeholder="Message"
                className="my-2 w-full resize-none border-0 bg-gray-100 px-4 pt-4 font-['Proxima_Nova_Alt_Light'] text-base font-black tracking-wide text-gray-700"
            />
            <br/>
            <input
                type="submit"
                value="Send Message"
                className="mt-4 h-12 w-full cursor-pointer border-0 bg-black px-0 font-['Proxima_Nova_Alt_Light'] text-sm font-black uppercase tracking-wide text-white"
            />
        </form>
    </>
}
